import { render, staticRenderFns } from "./SearchDialog.vue?vue&type=template&id=1061c7b8"
import script from "./SearchDialog.vue?vue&type=script&lang=js"
export * from "./SearchDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports